import { render, staticRenderFns } from "./ViewSettingsAliases.vue?vue&type=template&id=735de716&scoped=true&"
import script from "./ViewSettingsAliases.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsAliases.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsAliases.vue?vue&type=style&index=0&id=735de716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735de716",
  null
  
)

export default component.exports